module.exports = __webpack_public_path__ + "img/we_have.e6ba425f.png";